module.exports = __webpack_public_path__ + "resources/icon-write.1c45d9d27a07e3f4.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-comment/img/icon-write.png
// module id = 721
// module chunks = 0 1 2